export default __webpack_public_path__ + "static/itsnoissue-community-dcb4c608b302f0d6cc7eaa1b615e13b1.png";